exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1[data-v-1dbef0f0] {\n  margin-top: 300px;\n}\n", ""]);

// exports
